import { Component, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/api/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'underscore';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { environment } from 'src/app/environment';
import AlertifyHelper from 'src/app/utils/utils';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import { PartnersService } from 'src/app/api/collaborator/partners.service';

@Component({
  selector: 'app-partners-form',
  templateUrl: './partners-form.component.html',
  styleUrls: ['./partners-form.component.css']
})
export class PartnersFormComponent implements OnInit {
  branchofficeSlug: string = '';
  checkId: number;
  item: FormGroup;
  submitted: boolean = false;
  txtSubmenu: string = environment.txt_create_menu_form;
  isEdit: boolean = false;

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private globalService: GlobalService,
    private partnersService: PartnersService,
    private route: ActivatedRoute,
    private alertifyMsg: AlertifyHelper,
    private navigationTrackerService: NavigationTrackerService
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    this.checkId = this.route.snapshot.params['id'];
    this.item = this.fb.group({
      tradename: [null, [Validators.required, Validators.minLength(2)]],
      document: [null],
      fullname: [null],
      cellphone: [null],
      telephone: [null],
      email: [null, [Validators.email]],
      address: [null],
      number_workers: [null],
      date_birthday: [null]
    });

    if (!_.isUndefined(this.checkId)) {
      this.txtSubmenu = environment.txt_edit_menu_form;
      this.isEdit = true;
    }
  }

  ngOnInit() {
    this.navigationTrackerService.initializeMenu(this.route);
    if (this.isEdit) {
      this.editData();
    }
  }

  editData() {
    this.partnersService.get(this.checkId).subscribe({
      next: (data: any) => {
        let item_ = data.data;
        this.item.patchValue({
          tradename: item_.tradename,
          document: item_.document,
          fullname: item_.fullname,
          cellphone: item_.cellphone,
          telephone: item_.telephone,
          email:item_.email, 
          address: item_.email,
          number_workers: item_.number_workers, 
          date_birthday: item_.date_birthday,
        });
      }
    });
  }

  get f(): { [key: string]: AbstractControl } {
    return this.item.controls;
  }

  onSubmit() {
    this.submitted = true;
    if (this.item.invalid) {
      return;
    }
    if (this.validate()) {
      if (this.isEdit) {
        this.partnersService.update(this.checkId, this.item.value).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro actualizado con éxito');
            this.cancel();
          }
        });
      } else {
        this.partnersService.save(this.item.value).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro realizado con éxito');
            this.cancel();
          }
        });
      }
    }
  }

  validate() {
    return true;
  }

  cancel() {
    this.router.navigate([this.branchofficeSlug + '/colaborador/socios/lista']);
  }
}
